import React from 'react';
import { getConnectUrl } from 'utils';
import Lottie from 'lottie-react';

import styles from './NoMenus.module.scss';

interface Props {
  title: string;
  copy: string;
  imageSrc: string;
  reverse?: boolean;
  venueId?: string;
  lottieData?: unknown;
}

export const ImageAndText: React.FC<Props> = ({ title, copy, imageSrc, reverse, venueId, lottieData }) => {
  return (
    <section aria-labelledby={`${title.replaceAll(' ', '-')}-section`} className={styles.ImageAndText}>
      <div className={`${styles.Cont} ${reverse ? styles.Reverse : ''} container`}>
        <div className={styles.Image}>
          {lottieData ? (
            <Lottie animationData={lottieData} loop />
          ) : (
            <img src={imageSrc} alt={`${title}`} data-testid="ImageAndText-image" />
          )}
        </div>
        <div className={styles.Main}>
          <h2 id={`${title.replaceAll(' ', '-')}-section`}>{title}</h2>
          <div>{copy}</div>
          <a href={getConnectUrl(venueId, 'apps')}>
            <b>Connect ordering apps</b>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ImageAndText;
